import {
  Paper,
  Box,
  makeStyles,
  Typography,
  Button,
  Divider,
} from "@material-ui/core";
import { useContext } from "react";
import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";

const WALLET_WIDTH = 267;

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: WALLET_WIDTH,
    marginTop: 20,
    height: 700,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: theme.layout.walletPanel.backgroundColor,
  },
  topSection: {
    width: "100%",
    height: 107,
    minHeight: 107,
    maxHeight: 107,
    marginTop: 20,

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  midSection: {
    flexGrow: 1,
    flexBasis: "auto",
  },
  button: {
    width: 227,
    height: 78,
    marginBottom: 22,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  icon: {
    width: 40,
    height: 40,
  },
  buttonLabelContainer: {
    display: "flex",
    flexDirection: "column",
  },
  titleText: { fontSize: 14 },
  subtitleText: { fontSize: 10 },
  amount: {},
  bottomSection: {
    height: 61,
    width: "100%",
    padding: 5,
  },
  qrButton: {
    width: "100%",
  },
}));

const WalletPanel = ({ top, left }) => {
  const classes = useStyles();
  const [, dispatch] = useContext(PaymentCreateContext);
  return (
    <Paper
      className={classes.allContainer}
      style={{
        position: "fixed",
        top: top,
        left: left - WALLET_WIDTH,
      }}
    >
      <Box className={classes.topSection}>
        <AccountBalanceWalletIcon className={classes.icon} />
        <Typography>Select Your Wallet</Typography>
        <Button
          onClick={() =>
            dispatch({
              type: "HIDE_WALLET",
            })
          }
        >
          Close
        </Button>
        <Divider variant="fullWidth" style={{ width: "100%" }} />
      </Box>
      <Box className={classes.midSection}>
        <ButtonText
          className={classes.button}
          title="Point as cash"
          subtitle="No expire"
          amount="0"
          icon={<AccountBalanceWalletIcon className={classes.icon} />}
        ></ButtonText>
        <ButtonText
          className={classes.button}
          title="B-Wallet"
          subtitle="No expire"
          amount="0"
          icon={<AccountBalanceWalletIcon className={classes.icon} />}
        ></ButtonText>
        <ButtonText
          className={classes.button}
          title="Packages"
          subtitle="No expire"
          amount="0"
          icon={<AccountBalanceWalletIcon className={classes.icon} />}
        ></ButtonText>
        <ButtonText
          className={classes.button}
          title="Vouchers"
          subtitle="No expire"
          amount="0"
          icon={<AccountBalanceWalletIcon className={classes.icon} />}
        ></ButtonText>
      </Box>
      <Box className={classes.bottomSection}>
        <Button variant="outlined" className={classes.qrButton}>
          Scan QR Code
        </Button>
      </Box>
    </Paper>
  );
};

const ButtonText = ({ className, title, subtitle, amount, icon, onClick }) => {
  const classes = useStyles();
  return (
    <Button
      className={className}
      onClick={onClick}
      variant="contained"
      color="primary"
    >
      {icon}
      <Box className={classes.buttonLabelContainer}>
        <Typography className={classes.titleText}>{title}</Typography>
        <Typography className={classes.subtitleText}>{subtitle}</Typography>
      </Box>
      <Typography>{amount}</Typography>
    </Button>
  );
};

export default WalletPanel;
